(() => {
  const selector = '[data-dap-exhibition]';
  const bind = (section) => {
    if (section.dataset.dapExhibitionBound) return;
    section.dataset.dapExhibitionBound = 'true';
    const cards = [...section.querySelectorAll('[data-exhibition-art]')];
    let resizeFrame = 0;
    const lifecycle = new AbortController();
    const syncImageSizes = () => {
      cards.forEach((card) => {
        const image = card.querySelector('img');
        const width = card.querySelector('.dap-exhibition-image').clientWidth;
        if (width > 0 && image.sizes !== `${width}px`) image.sizes = `${width}px`;
      });
    };
    const resize = () => {
      if (!resizeFrame) resizeFrame = requestAnimationFrame(() => { resizeFrame = 0; syncImageSizes(); });
    };
    window.addEventListener('resize', resize, { passive: true, signal: lifecycle.signal });
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target !== section && !event.target.contains?.(section)) return;
      lifecycle.abort();
      cancelAnimationFrame(resizeFrame);
      delete section.dataset.dapExhibitionBound;
    }, { signal: lifecycle.signal });
    resize();
  };
  const bindWithin = (scope) => {
    if (scope.matches?.(selector)) bind(scope);
    scope.querySelectorAll(selector).forEach(bind);
  };
  bindWithin(document);
  document.addEventListener('shopify:section:load', (event) => bindWithin(event.target));
})();
